/**
 * @module
 * @description
 * Common directives shipped with Angular.
 */
export {NgClass} from './directives/ng_class';
export {NgFor} from './directives/ng_for';
export {NgIf} from './directives/ng_if';
export {NgTemplateOutlet} from './directives/ng_template_outlet';
export {NgStyle} from './directives/ng_style';
export {NgSwitch, NgSwitchWhen, NgSwitchDefault} from './directives/ng_switch';
export {NgPlural, NgPluralCase, NgLocalization} from './directives/ng_plural';
export {CORE_DIRECTIVES} from './directives/core_directives';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
